// Imports
import React from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components/macro';
import Tippy from '@tippyjs/react';
import tippyProps from '../../../../../../../shareables/foundation/front-end/utils/tippy-props';


// Styled components
const Wrapper = styled.div`
	display: flex;
	
	> span {
		margin-top: auto;
		margin-bottom: auto;
		
		> svg {
			margin-right: 0.5rem;
		}
	}
`;

const Text = styled.div`
	white-space: nowrap;
	width: 100%;
	margin-top: 0.1875rem;
`;


// Define the accepted props
interface Props {
	icon: IconDefinition;
	text: string | JSX.Element;
	tooltip: string;
}


// Function component
const OccurrenceDetail: React.FC<Props> = ({ icon, text, tooltip }) => {
	// Prevent some problematic usages
	if (icon.prefix !== 'far' && icon.prefix !== 'fab') {
		throw new Error('A detail’s icon should come from the "regular" or "brand" package');
	}
	
	
	// Return JSX
	return (
		<Wrapper>
			<Tippy {...tippyProps} content={tooltip}>
				<span>
					<FontAwesomeIcon icon={icon} fixedWidth className='is-gray' />
				</span>
			</Tippy>
			
			<Text>{text}</Text>
		</Wrapper>
	);
};

export default OccurrenceDetail;
